
import { defineComponent, PropType } from 'vue'
import { capitalize } from '@/utils/template'
import Size from '@/models/size'

export default defineComponent({
  name: 'ListHeader',
  props: {
    title: {
      type: String,
      require: true,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    size: {
      type: String as PropType<Size>,
      default: Size.medium
    },
    stick: {
      type: Boolean,
      default: true
    },
    highlight: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    return {
      capitalize,
      Size
    }
  }
})
